export const GET_ACCOUNTUSER_DATA = "GET_ACCOUNTUSER_DATA";
export const GET_ACCOUNTUSER_DATA_SUCCESS = "GET_ACCOUNTUSER_DATA_SUCCESS";
export const GET_ACCOUNTUSER_DATA_FAIL = "GET_ACCOUNTUSER_DATA_FAIL";